export default __webpack_public_path__ + "static/Selah-dac95d6aaa95e7fec4caa5e6201ab35c.webp";